export default __webpack_public_path__ + "static/media/TheBlue.b22f025f.png";